import { nsEnvelope } from '@/app/i18n/namespaces';

export default {
    UUID: {
        key: 'uuid'
    },
    CREATED_AT: {
        key: 'createdAt',
        type: 'date',
        entity: 'keys.download_codes.created_at',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: 'date'
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: 'date',
        entity: 'keys.envelopes.updated_at',
        enableSorting: true,
        filter: 'date'
    },
    ACCESS_CODE: {
        key: 'accessCode',
        type: 'text',
        entity: 'keys.envelopes.access_code',
        placeholder: 'filter.placeholder.envelopes.access_code',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: 'input'
    },
    DOWNLOAD_SERVER_IP_ADDRESS_PORT: {
        key: 'downloadServerIpAddressPort',
        type: 'text',
        entity: 'keys.envelopes.server_ip',
        placeholder: 'filter.placeholder.envelopes.download_server_ip_address_port',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: 'input'
    },
    SCHEDULED_START_DATE: {
        key: 'scheduledStartDate',
        type: 'date',
        entity: 'keys.envelopes.schedule_start',
        namespace: nsEnvelope,
        shouldShowHours: true,
        enableSorting: true,
        filter: 'date'
    },
    SCHEDULED_END_DATE: {
        key: 'scheduledEndDate',
        type: 'date',
        entity: 'keys.envelopes.schedule_end',
        namespace: nsEnvelope,
        shouldShowHours: true,
        enableSorting: true,
        filter: 'date'
    },
    DOWNLOAD_CODE_NAME: {
        key: 'downloadCodeName',
        type: 'text',
        entity: 'keys.envelopes.code_name',
        placeholder: 'filter.placeholder.download_codes.code_name',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: 'input'
    },
    CREATED_BY: {
        key: 'createdBy',
        type: 'text',
        entity: 'keys.download_codes.created_by',
        placeholder: 'filter.placeholder.download_codes.created_by',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: 'input'
    }
};